import { render } from "./ModalRemove.vue?vue&type=template&id=8f8e2330&scoped=true"
import script from "./ModalRemove.vue?vue&type=script&lang=js"
export * from "./ModalRemove.vue?vue&type=script&lang=js"

import "./ModalRemove.vue?vue&type=style&index=0&id=8f8e2330&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8f8e2330"

export default script